import React from 'react';
import MediaQuery from 'react-responsive';

interface MediaQueryProps {
  children: React.ReactNode;
  onChange?: (matches: boolean) => void;
  maxWidth?: string;
  minWidth?: string;
}

export const Mobile = (props: MediaQueryProps) => {
  return <MediaQuery maxWidth={767} {...props} />;
};

export const Desktop = (props: MediaQueryProps) => {
  return <MediaQuery minWidth={768} {...props} />;
};

export const LargeDesktop = (props: MediaQueryProps) => {
  return <MediaQuery minWidth={1200} {...props} />;
};

export const TableAndDektop = (props: MediaQueryProps) => {
  return <MediaQuery minWidth={768} maxWidth={1199} {...props} />;
};

export const Portrait = (props: MediaQueryProps) => {
  return <MediaQuery orientation="portrait" {...props} />;
};

export const Landscape = (props: MediaQueryProps) => {
  return <MediaQuery orientation="landscape" {...props} />;
};

export const MobileTableSmallDesktop = (props: MediaQueryProps) => {
  return <MediaQuery maxWidth={1199} {...props} />;
};
